/**
 * Cookbook Bundle free-gift sync — JackedInfo (getjcked.com) + JCKED (jcked.com).
 *
 * Adding the Anniversary Cookbook Bundle pulls in the 3 cookbooks plus the Shred
 * program. Removing the paid parent takes the gifts back out, and a gift-only cart
 * cannot reach checkout.
 *
 * Per-store config lives in STORES below. jcked.com only unlocks gifts from the
 * bundle itself; getjcked.com unlocks from any paid line because it is a
 * single-offer store.
 *
 * Default (full): Meal Prep + Desserts + Shred as FREE gifts.
 * OTP "Cookbooks Only": all 3 cookbooks, NO Shred.
 *
 * Respects user gift removals until the paid parent is removed and re-added.
 */
(function () {
  if (window.__JCKED_INFO_GIFTS__) return;
  window.__JCKED_INFO_GIFTS__ = true;

  var COOKBOOK_GIFT_HANDLES = [
    '50-recipe-single-serve-cookbook',
    '50-recipe-meal-prep-cookbook',
    '40-recipe-high-protein-desserts-cookbook',
  ];

  var STORES = {
    // getjcked.com — single-offer store, any paid line unlocks the gifts.
    'd5i265-tx.myshopify.com': {
      heroHandles: ['10-year-anniversary-cookbook-bundle', '100-day-shred-starter-kit'],
      heroHandleMatch: ['anniversary-cookbook-bundle', '100-day-shred-starter'],
      unlockOnAnyPaidItem: true,
      cookbookGifts: COOKBOOK_GIFT_HANDLES,
      shredHandle: 'jcked-100-day-shred-program',
      offerPath: 'pages/join-the-100-day-shred-program',
      redirectGiftPdps: true,
    },
    // jcked.com — full catalogue store, so only the bundle may unlock gifts.
    't14v0k-nw.myshopify.com': {
      heroHandles: ['10-year-anniversary-cookbook-bundle'],
      heroHandleMatch: ['anniversary-cookbook-bundle'],
      unlockOnAnyPaidItem: false,
      cookbookGifts: COOKBOOK_GIFT_HANDLES,
      shredHandle: 'jcked-100-day-shred-challenge',
      offerPath: 'pages/10-year-anniversary-cookbook-bundle',
      redirectGiftPdps: false,
    },
  };

  var shop = (window.Shopify && window.Shopify.shop) || '';
  var CFG = STORES[shop];
  if (!CFG) return;

  var HERO_HANDLES = CFG.heroHandles;
  var HERO_HANDLE_MATCH = CFG.heroHandleMatch;
  var COOKBOOK_GIFTS = CFG.cookbookGifts;
  var SHRED_HANDLE = CFG.shredHandle;
  var ALL_GIFT_HANDLES = COOKBOOK_GIFTS.concat([SHRED_HANDLE]);
  var PROP_KEY = '_info_hero_gift';
  var MODE_KEY = 'jck_info_gift_mode'; // 'full' | 'cookbooks'
  var DISMISS_KEY = 'jck_info_gift_dismissed';
  var variantCache = {};
  var giftItemCache = {};

  var syncing = false;
  var queued = false;
  var inflight = 0;
  var selfRequest = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(String(url || ''));
  }

  function isFree(item) {
    return Number(item.final_line_price) === 0 || Number(item.price) === 0;
  }

  function getMode() {
    try {
      return sessionStorage.getItem(MODE_KEY) === 'cookbooks' ? 'cookbooks' : 'full';
    } catch (e) {
      return 'full';
    }
  }

  function setMode(mode) {
    try {
      sessionStorage.setItem(MODE_KEY, mode === 'cookbooks' ? 'cookbooks' : 'full');
    } catch (e) {}
    clearDismissed();
    schedule(0);
  }

  function activeGiftHandles() {
    // OTP: 3 cookbooks only (no Shred). Full: all 3 cookbooks + Shred.
    // All gift products must be $0 in admin; UI can still show value prices.
    if (getMode() === 'cookbooks') return COOKBOOK_GIFTS.slice();
    return COOKBOOK_GIFTS.concat([SHRED_HANDLE]);
  }

  function readDismissed() {
    try {
      return JSON.parse(sessionStorage.getItem(DISMISS_KEY) || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function writeDismissed(list) {
    try {
      sessionStorage.setItem(DISMISS_KEY, JSON.stringify(list || []));
    } catch (e) {}
  }

  function clearDismissed() {
    writeDismissed([]);
  }

  function markDismissed(handle) {
    var list = readDismissed();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      writeDismissed(list);
    }
  }

  function isGiftHandle(handle) {
    return ALL_GIFT_HANDLES.indexOf(String(handle || '').toLowerCase()) !== -1;
  }

  function isHero(item) {
    var handle = String(item.handle || '').toLowerCase();
    if (isGiftHandle(handle)) return false;
    if (HERO_HANDLES.indexOf(handle) !== -1) return !isFree(item);
    for (var i = 0; i < HERO_HANDLE_MATCH.length; i++) {
      if (handle.indexOf(HERO_HANDLE_MATCH[i]) !== -1) return !isFree(item);
    }
    // Single-offer stores treat any paid line as the parent. On a full catalogue
    // that would hand out cookbooks with unrelated orders, so it stays off there.
    if (CFG.unlockOnAnyPaidItem && !isFree(item) && Number(item.final_line_price) > 0) return true;
    return false;
  }

  function heroQty(cart) {
    var qty = 0;
    (cart.items || []).forEach(function (item) {
      if (isHero(item)) qty += Number(item.quantity) || 0;
    });
    return qty;
  }

  function cartIsGiftOnly(cart) {
    var items = cart.items || [];
    if (!items.length) return false;
    return items.every(function (item) {
      return isGiftHandle(item.handle) || isFree(item);
    });
  }

  function blockGiftOnlyCheckout() {
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var checkout = t.closest(
          'button[name="checkout"], [name="checkout"], a[href*="/checkout"], .cart__checkout-button, #checkout'
        );
        if (!checkout) return;
        // Intercept until we know cart is valid (stops free-gift-only checkouts)
        e.preventDefault();
        e.stopPropagation();
        getCart().then(function (cart) {
          if (!cartIsGiftOnly(cart)) {
            if (checkout.tagName === 'A' && checkout.href) {
              window.location.href = checkout.href;
              return;
            }
            var form = checkout.closest('form');
            if (form) {
              form.submit();
              return;
            }
            window.location.href = root() + 'checkout';
            return;
          }
          var updates = {};
          (cart.items || []).forEach(function (item) {
            if (isGiftHandle(item.handle) || isFree(item)) updates[String(item.key)] = 0;
          });
          var go = function () {
            window.location.href = root() + CFG.offerPath;
          };
          if (Object.keys(updates).length) {
            updateCart(updates).then(go).catch(go);
          } else {
            go();
          }
        });
      },
      true
    );
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (t) {
          throw new Error(url + ' -> ' + res.status + ' ' + t);
        });
      }
      return res.json();
    });
  }

  function getCart() {
    return fetchJSON(root() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    });
  }

  function own(fn) {
    selfRequest = true;
    return Promise.resolve()
      .then(fn)
      .finally(function () {
        setTimeout(function () {
          selfRequest = false;
        }, 0);
      });
  }

  function resolveGiftItem(handle) {
    if (giftItemCache[handle]) return Promise.resolve(giftItemCache[handle]);
    return fetchJSON(root() + 'products/' + handle + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'force-cache',
    }).then(function (product) {
      var variant = (product.variants || [])[0];
      if (!variant || !variant.id) throw new Error('No variant for ' + handle);
      var entry = {
        id: Number(variant.id),
        quantity: 1,
        properties: {
          _free_gift: 'true',
          _info_hero_gift: 'true',
        },
      };
      if (handle === SHRED_HANDLE) {
        // Shred goes in as a free trial, so only a plan that charges $0 up front
        // qualifies. A plan with no first-cycle discount would bill full price at
        // checkout for something advertised as free, so skip rather than charge.
        var allocs = variant.selling_plan_allocations || [];
        var freeAlloc = null;
        for (var j = 0; j < allocs.length; j++) {
          if (Number(allocs[j].price) === 0 && allocs[j].selling_plan_id) {
            freeAlloc = allocs[j];
            break;
          }
        }
        if (!freeAlloc) {
          console.warn(
            '[info-hero-gifts] no $0 selling plan on ' + handle + ' - skipping Shred gift'
          );
          return null;
        }
        entry.selling_plan = Number(freeAlloc.selling_plan_id);
      }
      variantCache[handle] = entry.id;
      giftItemCache[handle] = entry;
      return entry;
    });
  }

  function resolveGiftItemSafe(handle) {
    return resolveGiftItem(handle).catch(function (err) {
      console.warn('[info-hero-gifts] could not resolve ' + handle, err);
      return null;
    });
  }

  function updateCart(updates) {
    return own(function () {
      return fetchJSON(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates }),
      });
    });
  }

  function addGifts(items) {
    if (!items.length) return Promise.resolve(null);
    return own(function () {
      return fetchJSON(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items }),
      });
    });
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      moveShredToBottom();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'info-hero-gifts' } }));
      return Promise.resolve();
    }
    return fetchJSON(root() + '?sections=cart-drawer', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (data) {
        if (data['cart-drawer']) drawer.renderContents({ sections: data });
      })
      .catch(function () {})
      .then(function () {
        moveShredToBottom();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'info-hero-gifts' } }));
      });
  }

  function moveShredToBottom() {
    var lists = document.querySelectorAll(
      '#CartDrawer-CartItems .cart-items, cart-drawer-items .cart-items, #main-cart-items .cart-items, .cart-items'
    );
    Array.prototype.forEach.call(lists, function (list) {
      var shred = list.querySelector('.cart-item--product-' + SHRED_HANDLE);
      if (shred && shred.parentNode === list) list.appendChild(shred);
    });
  }

  function sync() {
    if (inflight > 0) {
      queued = true;
      schedule(500);
      return;
    }
    if (syncing) {
      queued = true;
      return;
    }
    syncing = true;

    getCart()
      .then(function (cart) {
        var hasHero = heroQty(cart) >= 1;
        if (!hasHero) clearDismissed();

        var wanted = hasHero ? activeGiftHandles() : [];
        var dismissed = readDismissed();
        var updates = {};
        var needsUpdate = false;
        var present = {};

        (cart.items || []).forEach(function (item) {
          var handle = item.handle || '';
          var key = String(item.key || '');
          if (!key) return;
          if (ALL_GIFT_HANDLES.indexOf(handle) === -1) return;

          var marked = item.properties && item.properties[PROP_KEY] === 'true';

          // Always strip free gift SKUs when no paid parent (blocks dessert-only checkouts)
          if (!hasHero || wanted.indexOf(handle) === -1) {
            if (marked || isFree(item) || isGiftHandle(handle)) {
              updates[key] = 0;
              needsUpdate = true;
            }
            return;
          }

          // Shred must carry the Loop selling plan or no subscription is created.
          if (handle === SHRED_HANDLE && !item.selling_plan_allocation) {
            updates[key] = 0;
            needsUpdate = true;
            return;
          }

          present[handle] = true;
          if (Number(item.quantity) !== 1) {
            updates[key] = 1;
            needsUpdate = true;
          }
        });

        // Only add gifts that are wanted, not present, and not user-dismissed.
        // Dismissals come from captureDismissals() on cart remove — never inferred
        // from a partial sync (that races with multi-item add).
        var missing = wanted.filter(function (h) {
          if (present[h]) return false;
          if (dismissed.indexOf(h) !== -1) return false;
          return true;
        });

        if (!needsUpdate && !missing.length) return null;

        var chain = Promise.resolve();
        if (needsUpdate) {
          chain = chain.then(function () {
            return updateCart(updates);
          });
        }
        if (missing.length) {
          chain = chain.then(function () {
            return Promise.all(missing.map(resolveGiftItemSafe)).then(function (resolved) {
              var items = resolved.filter(Boolean);
              if (!items.length) return null;
              return getCart().then(function (fresh) {
                var stillMissing = items.filter(function (entry) {
                  return !(fresh.items || []).some(function (i) {
                    var sameVariant =
                      Number(i.id) === Number(entry.id) || Number(i.variant_id) === Number(entry.id);
                    if (!sameVariant) return false;
                    if (entry.selling_plan) {
                      return !!(i.selling_plan_allocation && i.selling_plan_allocation.selling_plan_id);
                    }
                    return true;
                  });
                });
                if (!stillMissing.length) return null;
                return addGifts(stillMissing);
              });
            });
          });
        }
        return chain.then(function () {
          return refreshDrawer();
        });
      })
      .catch(function (err) {
        console.warn('[info-hero-gifts]', err);
        schedule(1500);
      })
      .finally(function () {
        syncing = false;
        if (queued) {
          queued = false;
          schedule(400);
        }
      });
  }

  function schedule(ms) {
    clearTimeout(schedule._t);
    schedule._t = setTimeout(sync, typeof ms === 'number' ? ms : 700);
  }

  function onMutationEnd() {
    inflight = Math.max(0, inflight - 1);
    schedule(600);
  }

  function track(url, promise) {
    if (selfRequest) return;
    if (!isMutation(url)) return;
    inflight += 1;
    if (promise && typeof promise.then === 'function') {
      promise.then(onMutationEnd, onMutationEnd);
    } else {
      setTimeout(onMutationEnd, 800);
    }
  }

  // Before sync after a remove: if a gift handle disappeared while hero remains, dismiss it
  function captureDismissals(prevCart, nextCart) {
    if (!prevCart || !nextCart) return;
    if (heroQty(nextCart) < 1) return;
    var nextHandles = {};
    (nextCart.items || []).forEach(function (i) {
      nextHandles[i.handle] = true;
    });
    (prevCart.items || []).forEach(function (i) {
      if (ALL_GIFT_HANDLES.indexOf(i.handle) === -1) return;
      if (!nextHandles[i.handle]) markDismissed(i.handle);
    });
  }

  var _fetch = window.fetch;
  window.fetch = function () {
    var input = arguments[0];
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var args = arguments;
    if (!selfRequest && isMutation(url)) {
      return getCart()
        .then(function (before) {
          var p = _fetch.apply(window, args);
          track(url, p);
          p.then(function () {
            return getCart().then(function (after) {
              captureDismissals(before, after);
            });
          }).catch(function () {});
          return p;
        })
        .catch(function () {
          var p = _fetch.apply(window, args);
          track(url, p);
          return p;
        });
    }
    var p = _fetch.apply(this, arguments);
    track(url, p);
    return p;
  };

  document.addEventListener('cart:updated', function (e) {
    moveShredToBottom();
    if (e && e.detail && e.detail.source === 'info-hero-gifts') return;
    schedule(700);
  });
  document.addEventListener('theme:cart:change', function () {
    moveShredToBottom();
    schedule(700);
  });

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      // Fresh ATC of hero → clear dismissals so gifts come back
      if (
        t.closest(
          'button[name="add"], [name="add"], .product-form__submit, .add-to-cart, [data-add-to-cart], form[action*="/cart/add"] button'
        )
      ) {
        clearDismissed();
        schedule(800);
        setTimeout(function () {
          schedule(0);
        }, 1600);
        setTimeout(function () {
          schedule(0);
        }, 3200);
      }
      // Trash on gift line → mark dismissed (backup if fetch hook misses)
      var removeBtn = t.closest('[data-cart-remove], .cart-item__remove, cart-remove-button, a[href*="/cart/change"]');
      if (removeBtn) {
        var row = removeBtn.closest('[data-handle], .cart-item, .cart-drawer-item, li');
        var handle = row && (row.getAttribute('data-handle') || (row.className.match(/cart-item--product-([^\s]+)/) || [])[1]);
        if (handle && ALL_GIFT_HANDLES.indexOf(handle) !== -1) markDismissed(handle);
      }
    },
    true
  );

  // Gift PDPs: no solo purchase — send to paid offer
  if (CFG.redirectGiftPdps) {
    try {
      var path = (window.location && window.location.pathname) || '';
      COOKBOOK_GIFTS.forEach(function (h) {
        if (path.indexOf('/products/' + h) !== -1) {
          window.location.replace(root() + CFG.offerPath);
        }
      });
    } catch (e) {}
  }

  blockGiftOnlyCheckout();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      moveShredToBottom();
      schedule(800);
    });
  } else {
    moveShredToBottom();
    schedule(800);
  }

  window.JCKEDInfoHeroGifts = {
    sync: sync,
    schedule: schedule,
    setMode: setMode,
    getMode: getMode,
    clearDismissed: clearDismissed,
  };
})();
